
import { AfterViewInit, ChangeDetectorRef, Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild, inject, signal } from '@angular/core';

import { FormBuilder, FormControl, FormGroup, FormsModule, Validators } from '@angular/forms';
import { ChangeDetectionStrategy } from '@angular/core';
import { CaptchaService } from '../../../shared/services/captcha.service';
import { DomSanitizer } from '@angular/platform-browser';
import { MatIconRegistry, MatIconModule } from '@angular/material/icon';
import { ApiService } from '../../../shared/services/api.service';
import { API_ENDPOINTS } from '../../../shared/utils/const';
import { ToastrService } from 'ngx-toastr';
import { ActivatedRoute, ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { MatRadioChange } from '@angular/material/radio';
import { CryptoService } from '../../../shared/services/crypto.service';
import { MatDialog } from '@angular/material/dialog';
import { TimerDialogComponent } from '../../../timer-dialog/timer-dialog.component';

const THUMBUP_ICON =
  `
  <svg xmlns="http://www.w3.org/2000/svg" width="24px" height="24px">
    <path d="M0 0h24v24H0z" fill="none"/>
    <path d="M1 21h4V9H1v12zm22-11c0-1.1-.9-2-2-2h-6.31l.95-4.57.03-.32c0-.41-.17-.79-.` +
  `44-1.06L14.17 1 7.59 7.59C7.22 7.95 7 8.45 7 9v10c0 1.1.9 2 2 2h9c.83 0 1.54-.5` +
  `1.84-1.22l3.02-7.05c.09-.23.14-.47.14-.73v-1.91l-.01-.01L23 10z"/>
  </svg>
`;

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrl: './login.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,

})

export class LoginComponent implements OnInit, AfterViewInit {

  captcha!: string;
  userInput!: string;
  captchaError: boolean = false;
  captchaSuccess: boolean = false;
  invalidCredentialMsg!: string;
  username!: string;
  password!: string;
  retUrl!: string;
  userType: string = '';
  MSSIDCUserName: any;
  routeSnapshot: any;

  isPasswordVisible: boolean = false;

  @ViewChild('#submitBtn') submitButton!: ElementRef;

  
  constructor(private captchaService: CaptchaService, private router: Router, private apiService: ApiService,
    private toastr: ToastrService, private cryptoService: CryptoService, private cdr: ChangeDetectorRef, private dialog: MatDialog) {
    //const routeSnapshot = this.route.snapshot;
    const iconRegistry = inject(MatIconRegistry);
    const sanitizer = inject(DomSanitizer);
    iconRegistry.addSvgIconLiteral('thumbs-up', sanitizer.bypassSecurityTrustHtml(THUMBUP_ICON));

    // Enforce max length using valueChanges
    this.form.get('captcha')?.valueChanges.subscribe((value: string | null) => {
      if (value && value.length > 6) {
        // Trim the value to max 6 characters and update form control without emitting events
        this.form.get('captcha')?.setValue(value.slice(0, 6), { emitEvent: false });
      }
    });

  }


  public userData = {
    msMeUserId: '',
    msMeUserName: '',
    name: '',
    ownersMobileNumber: '',
    message: '',
    loginStatus: '',
    token: '',
    isActive: false,
    userId: '',
    email: ''
  };

  public iauserData = {
    industryAssociationUserId: '',
    iaUserName: '',
    name: '',
    email: '',
    mobileNumber: '',
    message: '',
    status: '',
    token: '',
    userId: '',
    isActive: false
  };

  public mssidcuserData = {
    userMasterUserId: '',
    mssidcUserName:'',
    name: '',
    mobile: '',
    email: '',
    message: '',
    status: '',
    token: '',
    isActive: false
  };

  public dicuserData = {
    userMasterUserId: '',
    dicUserName:'',
    name: '',
    mobile: '',
    email: '',
    districtName: '',
    districtCode:'',
    message: '',
    status: '',
    token: '',
    isActive: false
  };

  maxAttempts = 3;
  lockoutDuration = 60;
  remainingTime: number = 0;
  isLocked: boolean = false;
  interval: any;

  ngOnInit() {
    sessionStorage.clear();
    //this.generateCaptcha();
    this.userType = this.form.controls.signinas.value as string;
    this.checkLockoutStatus();

    this.submitButton?.nativeElement.click(); // Simulate button click

    //window.history.pushState(null, '', window.location.href);
    //window.onpopstate = () => {
    //  this.router.navigateByUrl("/login");

    //const button = document.querySelector('button[type="submit"]') as HTMLButtonElement;
    //if (button) {
    //  button.click(); // Simulates a real click
    //}

  }


  //ngAfterViewInit() {
  //  this.generateCaptcha();
  //}

  ngAfterViewInit() {
    setTimeout(() => {
      this.generateCaptcha();
    }, 5);
  }

  generateCaptcha(): void {

    this.form.get('captcha')?.setValue('');
    this.captcha = this.captchaService.generateCaptcha();
    this.drawCaptcha();
  }

  

  //Added by sayali
  drawCaptcha(): void {
    const canvas: HTMLCanvasElement = document.getElementById('captchaCanvas') as HTMLCanvasElement;
    const context = canvas.getContext('2d');

    if (context) {
      // Clear the canvas
      context.clearRect(0, 0, canvas.width, canvas.height);

      // Set font and text color
      context.font = '30px sans-serif';
      context.fillStyle = '#5e5c5c';

      // Calculate text dimensions and padding
      const textWidth = context.measureText(this.captcha).width;
      const textHeight = 30; // Approximate height for 30px font
      const padding = 10; // Padding around the text

      // Define box dimensions
      const boxX = 5;
      const boxY = 5;
      const boxWidth = textWidth + padding * 2;
      const boxHeight = textHeight + padding * 2;

      // Draw the text
      context.fillText(this.captcha, boxX + padding, boxY + textHeight + padding / 2);

      // Draw the box around the text
      context.strokeStyle = '#5e5c5c';
      context.lineWidth = 1;
      context.strokeRect(boxX, boxY, boxWidth, boxHeight);
    }
  }

  preventSpecialChars(event: KeyboardEvent) {
    const regex = /^[a-zA-Z0-9]$/;
    if (!regex.test(event.key)) {
      event.preventDefault();
    }
  }

  
  resetForm(): void {
    const currentValue = this.form.get('signinas')?.value;
    this.form.reset();
    this.form.patchValue({ signinas: currentValue });
    this.captchaError = false;
  }

  onSignInAsChange(event: MatRadioChange): void {
    const selectedValue = event.value;
    this.resetForm();
  }

  get f() { return this.form.controls }

  form = new FormGroup({
    signinas: new FormControl('MSME', [Validators.required]),
    username: new FormControl('', [Validators.required,]),
    password: new FormControl('', [Validators.required,]),
    captcha: new FormControl('', [Validators.required,])
  });

  public loginObj: any = {
    username: '',
    password: '',
    userType: ''
  }
  isError: boolean = false;
  serverError: boolean = false;
  moduleType: any;


  /* Added by Sayali */

  onKeyPress(event: KeyboardEvent, form: any) {
    if (event.key === 'Enter') {
      //this.msg = 'Form submitted...!';
      event.preventDefault();
      this.mainLogin();
    }
  }



  togglePasswordVisibility() {
    this.isPasswordVisible = !this.isPasswordVisible;
  }



  mainLogin(): void {

    if (this.isLocked) {
      this.toastr.error(`Too many failed attempts. Try again in ${this.remainingTime} seconds.`);
      return;
    }

    if (this.form.invalid) {
      alert("Please enter valid inputs to Login");
      return;
    }

    const userinput = this.form.controls.captcha.value as string;
    if (this.captchaService.validateCaptcha(userinput, this.captcha)) {
      // Captcha validation successful
      this.captchaSuccess = true;
      this.captchaError = false; // Reset error flag

      switch (this.form.controls.signinas.value) {
        case "MSME":
          this.MSMElogin();
          //this.routeSnapshot.data['role'] = 'msme';  
          break;

        case "IA":
          this.IAlogin();
          //this.routeSnapshot.data['role'] = 'ia';
          //this.router.navigateByUrl("/app-register-ia-page1");
          break;

        case "MSSIDC":
          this.MSSIDClogin();
          //this.routeSnapshot.data['role'] = 'mssidc';
          break;

        case "DIC":
          this.DIClogin();
          //this.routeSnapshot.data['role'] = 'dic';
          break;

        default:
          alert("Invalid selection.");
          break;
      }
    } else {
      //this.handleFailedAttempt();
      this.captchaError = true;
      this.captchaSuccess = false; // Reset success flag
      this.form.controls.captcha.reset();
      this.generateCaptcha();

      //this.form.reset();
    }
    //console.log("------" + this.isLocked);
  }


  MSMElogin() {
    if (this.isLocked) {
      this.toastr.error(`Too many failed attempts. Try again in ${this.remainingTime} seconds.`);
      return;
    }

    const { username, password } = this.form.value;

    if (!username || !password) {
      this.toastr.error('Username and password are required.');
      return;
    }

    // Encrypt credentials
    this.loginObj = {
      username: this.cryptoService.encryptnew(username),
      password: this.cryptoService.encryptnew(password),
      userType: ''
    };

    this.serverError = false;
    let isMSMELoginSuccessful = false; // Flag to track success or failure

    this.apiService.postRequest(API_ENDPOINTS.LOGIN.MSME, this.loginObj).subscribe({
      next: (res) => {
        if (res.status) {
          // Login successful
          isMSMELoginSuccessful = true;
          this.toastr.success(res.message);
          sessionStorage.setItem('authToken', res.token);
          sessionStorage.setItem('singInAs', 'MsMeUser');
          sessionStorage.setItem('isUserLoggedIn', 'true');
          sessionStorage.setItem('UserType', 'MSME');
          sessionStorage.setItem('isApproved', res.isApproved);
          sessionStorage.setItem('isProfileCompleted', res.isProfileCompleted);
          sessionStorage.setItem('Gender', res.gender);
          sessionStorage.setItem('SocialCategory', res.socialCategory);
          this.userData = {
            msMeUserId: res.msMeUserId,
            msMeUserName: res.msMeUserName,
            name: res.name,
            ownersMobileNumber: res.ownersMobileNumber,
            message: res.message,
            loginStatus: res.status,
            token: res.token,
            isActive: res.isActive,
            userId: res.msMeId,
            email: res.email,
          };

          Object.keys(this.userData).forEach((key) => {
            const value = this.userData[key as keyof typeof this.userData];
            sessionStorage.setItem(key, String(value));
          });

          this.router.navigate(['/msmeuserprofile']);
        }
        else {
          // Login failed
          //this.handleFailedAttempt();
          isMSMELoginSuccessful = false;
          this.toastr.error(res.message);
          this.router.navigate(['/login']);
        }
      },
      error: (err) => {
        //      this.generateCaptcha();
        //this.handleFailedAttempt();
        this.form.controls.captcha.reset();
        this.generateCaptcha();

      },
      complete: () => {
        // Check the success flag and refresh captcha if needed
        if (!isMSMELoginSuccessful) {
          this.form.controls.captcha.reset();
          this.generateCaptcha(); // Refresh captcha on failure or error
        }
      },
    });
  }

  IAlogin() {
    if (this.isLocked) {
      this.toastr.error(`Too many failed attempts. Try again in ${this.remainingTime} seconds.`);
      return;
    }
    // Encrypt the password if needed
    // const encryptedPassword = this.cryptoService.encrypt(this.loginObj.password);
    // this.loginObj.password = encryptedPassword;

    const { username, password } = this.form.value;

    if (!username || !password) {
      this.toastr.error('Username and password are required.');
      return;
    }

    // Encrypt credentials
    this.loginObj = {
      username: this.cryptoService.encryptnew(username),
      password: this.cryptoService.encryptnew(password),
      userType: ''
    };

    this.serverError = false;

    let isIALoginSuccessful = false; // Flag to track success or failure

    this.apiService.postRequest(API_ENDPOINTS.LOGIN.IA, this.loginObj).subscribe({
      next: (res) => {
        if (res.status) {
          // Login successful
          isIALoginSuccessful = true;
          this.toastr.success(res.message);
          sessionStorage.setItem('authToken', res.token);
          sessionStorage.setItem('singInAs', 'IAUser');
          sessionStorage.setItem('isUserLoggedIn', "true");
          sessionStorage.setItem('iauserid', res.industryAssociationId);
          sessionStorage.setItem('UserType', 'IA');
          sessionStorage.setItem('isProfileCompleted', res.isProfileCompleted);
          this.iauserData = {
            industryAssociationUserId: res.industryAssociationUserId,
            iaUserName: res.iaUserName,
            name: res.nameOfOrganisation,
            email: res.email,
            mobileNumber: res.mobileNumber,
            message: res.message,
            status: res.status,
            token: res.token,
            isActive: res.isActive,
            userId: res.industryAssociationId,
          };

          Object.keys(this.iauserData).forEach((key) => {
            const value = this.iauserData[key as keyof typeof this.iauserData];
            sessionStorage.setItem(key, String(value));
          });

          // Redirect based on isProfileCompleted
          if (res.isProfileCompleted) {
            this.router.navigate(['/iauserdashboard']);
          } else {
            this.router.navigate(['/iaprofile']);
          }
        } else {
          // Login failed
          isIALoginSuccessful = false;
          this.toastr.error(res.message);
          this.router.navigate(['/login']);
        }
      },
      error: (err) => {
        //console.error('Error occurred:', err);
        //      //let errorMessage = "An error occurred during login.";

        //      //switch (err.status) {
        //      //  case 401:
        //      //    errorMessage = "Unauthorized: Invalid Password";
        //      //    break;
        //      //  case 403:
        //      //    errorMessage = "Forbidden: Access is denied.";
        //      //    break;
        //      //  case 404:
        //      //    errorMessage = "User Not Found";
        //      //    break;
        //      //  default:
        //      //    errorMessage = "Unexpected error occurred.";
        //      //}

        //      //alert(errorMessage);
        this.form.controls.captcha.reset();
        this.generateCaptcha();


      },
      complete: () => {
        // Check the success flag and refresh captcha if needed
        if (!isIALoginSuccessful) {
          this.form.controls.captcha.reset();
          this.generateCaptcha(); // Refresh captcha on failure or error
        }
      },
    });
  }


  MSSIDClogin() {
    if (this.isLocked) {
      this.toastr.error(`Too many failed attempts. Try again in ${this.remainingTime} seconds.`);
      return;
    }
    //this.loginObj.username = this.form.value.username;
    //this.loginObj.password = this.form.value.password;
    //this.loginObj.userType = this.form.controls.signinas.value;

    //this.MSSIDCUserName = this.loginObj.username;

    const { username, password, } = this.form.value;

    if (!username || !password) {
      this.toastr.error('Username and password are required.');
      return;
    }

    // Encrypt credentials
    this.loginObj = {
      username: this.cryptoService.encryptnew(username),
      password: this.cryptoService.encryptnew(password),
      userType: this.form.controls.signinas.value,
    };

    this.serverError = false;
    let isMSSIDCLoginSuccessful = false; // Flag to track success or failure

    this.apiService.postRequest(API_ENDPOINTS.LOGIN.MSSIDC, this.loginObj).subscribe({
      next: (res) => {
        if (res.status) {
          // Login successful
          isMSSIDCLoginSuccessful = true;

          this.mssidcuserData = {
            userMasterUserId: res.userMasterUserId,
            mssidcUserName:res.userName,
            name: res.userName,
            email: res.email,
            mobile: res.mobile,
            message: res.message,
            status: res.status,
            token: res.token,
            isActive: res.isActive,
          };

          this.toastr.success(res.message);
          sessionStorage.setItem('authToken', res.token);
          sessionStorage.setItem('singInAs', 'MSSIDCUser');
          sessionStorage.setItem('isAdminLoggedIn', "true");
          sessionStorage.setItem('mssidcuserid', res.userMasterUserId);
          sessionStorage.setItem('UserType', 'MSSIDC');    

          

          Object.keys(this.mssidcuserData).forEach((key) => {
            const value = this.mssidcuserData[key as keyof typeof this.mssidcuserData];
            sessionStorage.setItem(key, String(value));
          });

          sessionStorage.setItem('readonlyUsername', JSON.stringify(res.mssidcUserName));
          this.router.navigate(['/mssidcdashboard']);
          // this.router.navigate(['/msmeverification']);
        } else {
          // Login failed
          isMSSIDCLoginSuccessful = false;
          this.toastr.error(res.message);
          this.router.navigate(['/login']);
        }
      },
      error: (err) => {
        //console.error('Error occurred:', err);
        //      //let errorMessage = "An error occurred during login.";

        //      //switch (err.status) {
        //      //  case 401:
        //      //    errorMessage = "Unauthorized: Invalid Password";
        //      //    break;
        //      //  case 403:
        //      //    errorMessage = "Forbidden: Access is denied.";
        //      //    break;
        //      //  case 404:
        //      //    errorMessage = "User Not Found";
        //      //    break;
        //      //  default:
        //      //    errorMessage = "Unexpected error occurred.";
        //      //}

        //      //alert(errorMessage);
        this.form.controls.captcha.reset();
        this.generateCaptcha();
      },
      complete: () => {
        // Refresh captcha if login failed
        if (!isMSSIDCLoginSuccessful) {
          this.form.controls.captcha.reset();
          this.generateCaptcha();
        }
      },
    });
  }


  DIClogin() {
    if (this.isLocked) {
      this.toastr.error(`Too many failed attempts. Try again in ${this.remainingTime} seconds.`);
      return;
    }
    //this.loginObj.username = this.form.value.username;
    //this.loginObj.password = this.form.value.password;
    //this.loginObj.userType = this.form.controls.signinas.value;

    this.MSSIDCUserName = this.loginObj.username;

    const { username, password, } = this.form.value;

    if (!username || !password) {
      this.toastr.error('Username and password are required.');
      return;
    }

    // Encrypt credentials
    this.loginObj = {
      username: this.cryptoService.encryptnew(username),
      password: this.cryptoService.encryptnew(password),
      userType: this.form.controls.signinas.value,
    };

    this.serverError = false;
    let isDICLoginSuccessful = false; // Flag to track success or failure

    this.apiService.postRequest(API_ENDPOINTS.LOGIN.DIC, this.loginObj).subscribe({
      next: (res) => {
        if (res.status) {
          // Login successful
          isDICLoginSuccessful = true;
          this.toastr.success(res.message);
          sessionStorage.setItem('authToken', res.token);
          sessionStorage.setItem('singInAs', 'DICUser');
          sessionStorage.setItem('isUserLoggedIn', 'true');
          sessionStorage.setItem('dicUserId', res.userMasterUserId);
          sessionStorage.setItem('UserType', 'DIC');

          this.dicuserData = {
            userMasterUserId: res.userMasterUserId,
            name: res.userName,
            dicUserName:res.userName,
            email: res.email,
            mobile: res.mobile,
            districtName: res.districtName,
            districtCode: res.districtCode,
            message: res.message,
            status: res.status,
            token: res.token,
            isActive: res.isActive,
          };

          Object.keys(this.dicuserData).forEach((key) => {
            const value = this.dicuserData[key as keyof typeof this.dicuserData];
            sessionStorage.setItem(key, String(value));
          });
          sessionStorage.setItem('readonlyUsername', JSON.stringify(res.dicUserName));
          this.router.navigate(['/dicdashboard']);
        } else {
          // Login failed
          isDICLoginSuccessful = false;
          this.toastr.error(res.message);
          this.router.navigate(['/login']);
        }
      },
      error: (err) => {
        //console.error('Error occurred:', err);
        //      //let errorMessage = "An error occurred during login.";

        //      //switch (err.status) {
        //      //  case 401:
        //      //    errorMessage = "Unauthorized: Invalid Password";
        //      //    break;
        //      //  case 403:
        //      //    errorMessage = "Forbidden: Access is denied.";
        //      //    break;
        //      //  case 404:
        //      //    errorMessage = "User Not Found";
        //      //    break;
        //      //  default:
        //      //    errorMessage = "Unexpected error occurred.";
        //      //}

        //      //alert(errorMessage);
        this.form.controls.captcha.reset();
        this.generateCaptcha();
      },
      complete: () => {
        // Check the success flag and refresh captcha if needed
        if (!isDICLoginSuccessful) {
          this.form.controls.captcha.reset();
          this.generateCaptcha(); // Refresh captcha on failure or error
        }
      },
    });
  }

  /*Testing for Account Lockout*/
  
  checkLockoutStatus() {
    //console.log("🔍 Checking lockout status...");

    if (!this.userType) {
     // console.warn("⚠ `this.userType` is undefined, cannot check lockout status.");
      return;
    }

    const lockoutTime = Number(localStorage.getItem(`lockoutTime_${this.userType}`)) || 0;
    const currentTime = Date.now();

    //console.log("🕒 Lockout time from storage:", lockoutTime, "Current time:", currentTime);

    if (lockoutTime > currentTime) {
      //console.log("🔒 User is locked out! Starting timer...");
      this.startTimer(lockoutTime);
    } else {
     // console.log("✅ No active lockout. Resetting values.");
      this.resetLockout();
    }
  }

  handleFailedAttempt(err: any) {
    if (err.error?.message === "Too many failed attempts. Try again later.") {
      //console.warn("🚨 Lockout triggered: Showing Timer Dialog...");
      this.openTimerDialog(180); // 3-minute timer
    }
  }

  openTimerDialog(duration: number) {
    const dialogRef = this.dialog.open(TimerDialogComponent, {
      width: '400px',
      disableClose: true, // Prevent user from closing manually
      data: { duration }
    });

    dialogRef.afterClosed().subscribe(() => {
      //console.log("✅ Timer completed. Unlocking user.");
      this.isLocked = false;
    });
  }

  startTimer(lockoutTime: number) {
   // console.log("🔹 Timer function started!");

    this.isLocked = true;
    const currentTime = Date.now();

    if (lockoutTime <= currentTime) {
      //console.warn("⚠ Lockout time has expired. Resetting lockout.");
      this.resetLockout();
      return;
    }

    this.remainingTime = Math.ceil((lockoutTime - currentTime) / 1000);
    //console.log("⏳ Initial remaining time:", this.remainingTime);
    this.cdr.detectChanges(); // Force UI update

    if (this.remainingTime <= 0) {
      this.resetLockout();
      return;
    }

    this.interval = setInterval(() => {
      this.remainingTime--;
      //console.log("⏳ Time left:", this.remainingTime);
      this.cdr.detectChanges(); // Update UI every second

      if (this.remainingTime <= 0) {
        //console.log("✅ Timer completed. Unlocking user.");
        this.resetLockout();
      }
    }, 1000);
  }

  resetLockout() {
    //console.log("🔓 Resetting lockout status...");
    clearInterval(this.interval);
    this.isLocked = false;
    this.remainingTime = 0;
    localStorage.removeItem(`lockoutTime_${this.userType}`);
    localStorage.removeItem(`failedAttempts_${this.userType}`);
    this.cdr.detectChanges();
  }

  openIAUserManual() {
    var filePath = 'Images\\UserManual\\IA\\RAMP-Portal-UserManul-For-V1-IA.pdf';
    var fileName = 'RAMP-Portal-UserManul-For-V1-IA.pdf';
    this.apiService.downloadFile(filePath).subscribe({
      next: (blob) => {
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = fileName || 'download.pdf';
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(url);
      },
      error: (error) => {
        console.error('Download failed:', error);
      }
    });
  }

  openMSMEUserManual() {
    var filePath = 'Images\\UserManual\\MSME\\RAMP-Portal-UserManul-For-V1-MSME.pdf';
    var fileName = 'RAMP-Portal-UserManul-For-V1-MSME.pdf';
    this.apiService.downloadFile(filePath).subscribe({
      next: (blob) => {
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = fileName || 'download.pdf';
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(url);
      },
      error: (error) => {
        console.error('Download failed:', error);
      }
    });
  }



}





